const API_BASE_URL = 'https://new.sbdemolition.online/api';

const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken');

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      credentials: 'include',
      headers: {
        // لا تضيف Content-Type هنا للـ FormData
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    });

    const text = await response.text();
    console.log('API Response:', text.substring(0, 500));

    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error('Failed to parse JSON. Response:', text.substring(0, 500));
      throw new Error('Server returned invalid response. Raw: ' + text.substring(0, 100));
    }

    if (!response.ok) {
      throw new Error(data.error || data.message || `HTTP ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error('API Fetch Error:', error);
    throw error;
  }
};

export const dailyReportsAPI = {
  list: async (projectId = null) => {
    const url = projectId
      ? `/daily-reports/list.php?projectId=${projectId}`
      : '/daily-reports/list.php';
    return await apiFetch(url, { method: 'GET' });
  },

  create: async (reportData) => {
    console.log('Sending report data:', reportData);
    
    // ✅ إذا كان FormData، أرسله مباشرة بدون JSON.stringify
    if (reportData instanceof FormData) {
      return await apiFetch('/daily-reports/create.php', {
        method: 'POST',
        body: reportData,
        headers: {
          // لا تضيف Content-Type - المتصفح يضيفه تلقائياً مع boundary
        }
      });
    }
    
    // إذا كان object عادي، حوله لـ JSON
    return await apiFetch('/daily-reports/create.php', {
      method: 'POST',
      body: JSON.stringify(reportData),
      headers: {
        'Content-Type': 'application/json',
      }
    });
  },

  updateAdminNote: async (reportId, adminNotes) => {
    return await apiFetch('/daily-reports/update.php', {
      method: 'POST',
      body: JSON.stringify({ id: reportId, adminNotes }),
    });
  },

  delete: async (reportId) => {
    return await apiFetch(`/daily-reports/delete.php?id=${reportId}`, {
      method: 'DELETE',
    });
  },
};
